import React from 'react';
import tapTabLogo from '../../assets/images/TapTabLargeLogoWhite.png';
import './styles/_profile-section-page.scss';

interface ProfileSectionPageProps {
  title: string;
  children: React.ReactNode;
}

const ProfileSectionPage = ({ title, children }: ProfileSectionPageProps) => (
  <div className="profile-section-page-container">
    <div className="profile-section-page-hero-background" />

    <div className="profile-section-page-scroll-body">
      <div className="profile-section-page-header">
        <div className="profile-section-page-header-badge">
          <img src={tapTabLogo} alt="" className="profile-section-page-header-logo" aria-hidden />
          <h1 className="profile-section-page-header-title">{title}</h1>
        </div>
      </div>
      <div className="profile-section-page-content">{children}</div>
    </div>
  </div>
);

export default ProfileSectionPage;
